import React, { useState, useEffect } from "react";
import { getAccessTokenApi, logout, decodedToken } from "../api/auth";

export const AuthContext = React.createContext();

export default function AuthProvider(props) {
  const { children } = props;

  const [user, setUser] = useState({
    user: null,
    isLoading: true,
    isAdmin: null,
    isParticipante: null
  });

  useEffect(() => {
    checkUserLogin(setUser);
  }, []);
  //console.log(user, "setUSer");

  return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>;
}

/**
 * Revisa si el usuario esta logueado
 * Si los token estan bien estructurados, decodifica el valor del token de acceso y devuelve sus valores: {id, name, lastname, username, role}
 * @param {Function} setUser
 */
async function checkUserLogin(setUser) {
  const accessToken = getAccessTokenApi();

  if (!accessToken) {
    logout();
    setUser({
      user: null,
      isLoading: false,
      isAdmin: null,
      isParticipante: null,
      isOrganizador: null
    });
  } else {
    const user = decodedToken(accessToken);
    setUser({
      isLoading: false,
      user: user,
      isAdmin: user.role === "admin",
      isParticipante: user.role === "participante",
      isOrganizador: user.role === "organizer"
    });
    // console.log(user, "user");
  }
}
